import { useMemo } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { GridColDef } from '@mui/x-data-grid';
import { LineOfBusinessListItem } from '@libs/models/linesOfBusiness';

export function useLinesOfBusinessSettingsColumns({ localizationSubset }: { localizationSubset: string }) {
  const intl = useIntl();
  // Columns should be memoized to prevent table flickering and state loss
  return useMemo(() => {
    const columns: GridColDef<LineOfBusinessListItem>[] = [getNameColumn(intl, localizationSubset)];
    return columns;
  }, [intl]);
}

function getNameColumn(intl: IntlShape, localizationSubset: string): GridColDef<LineOfBusinessListItem> {
  return {
    field: 'name',
    headerName: intl.formatMessage({ id: `${localizationSubset}.table.fields.name.heading` }),
    minWidth: 160,
    resizable: true,
    display: 'flex',
    flex: 1,
    sortable: true,
    filterable: false,
  };
}
